'use client';

import RialBlueIso from '@/assets/icon/RialBlueIso';
import model from '@/assets/model/m-2.webp';
import ImageWithLoader from '@/components/common/images/ImageWithLoader';
import { ContactUsForm } from './components/ContactUsForm';

export default function ContactUs() {
  return (
    <div className="w-full min-w-96 p-4 flex flex-col justify-center items-center gap-16 overflow-hidden">
      <div className="flex flex-col justify-center items-center gap-6">
        <RialBlueIso className="w-32" />
        <div className="text-center text-gray-950 text-5xl font-semibold leading-[60px]">
          Contáctanos
        </div>
        <div className="text-center text-gray-800 text-xl font-normal leading-loose">
          Conversemos. Nuestro equipo está aquí para ayudarte a escalar tus campañas de moda con IA.
        </div>
      </div>
      <div className="flex flex-col justify-center items-center gap-6 w-full">
        <div className="flex flex-row justify-center items-center gap-6 w-full h-[700px]">
          <ContactUsForm />
          <div className="rounded-3xl overflow-hidden w-1/2 h-full hidden lg:block">
            <ImageWithLoader
              src={model}
              alt="model"
              width={2000}
              height={2000}
              className="rounded-2xl object-cover h-full w-full"
              style={{
                objectPosition: 'center 5%',
              }}
            />
          </div>
        </div>
        <div className="flex flex-col justify-start items-start gap-4 xl:w-5/6 w-full 2xl:w-3/4">
          <div className="h-6 text-center text-gray-400 text-base font-medium font-['Inter'] leading-normal">
            Email
          </div>
          <div className="text-center text-black text-sm font-normal font-['Inter'] leading-tight">
            contacto@rial-ai.com
          </div>
        </div>
      </div>
    </div>
  );
}
